<template>
<div class="map-type-menu">
	<button @click="toggleMenu()">
		<img src="../../../assets/images/map_type_icon.svg" alt="type-menu">
	</button>
	<div class="menu" id="mapTypeMenu">
		<span class="title">Map View:</span>
		<ul>
			<li>
				<a>Discovery</a>
			</li>
			<li>
				<a>Population</a>
			</li>
			<li>
				<a>Precipitation</a>
			</li>
			<li>
				<a>Terrorism Attack</a>
			</li>
			<li>
				<a>Elevation</a>
			</li>
		</ul>
	</div>
</div>
</template>

<script>
export default {
	data: () => ({
		showMenu: false
	}),
	mounted() {
		this.$root.$on('hideMapTypeMenu', () => {
			this.showMenu = false
			let menuElement = document.getElementById('mapTypeMenu')
			menuElement.style.right = '-495px'
		})
	},
	methods: {
		toggleMenu() {
			this.showMenu = !this.showMenu
			let menuElement = document.getElementById('mapTypeMenu')
			if(this.showMenu) {
				menuElement.style.right = '55px'
			} else {
				menuElement.style.right = '-495px'
			}
		}
	}
}
</script>

<style lang="scss">
.map-type-menu {
	position: absolute;
	right: 0;
	top: 0;
	overflow: hidden;
	width: 605px;
	height: 55px;

	button {
		border: none;
		background: linear-gradient(to left bottom, #3b9fce 50%, #54b1d7 50%);
		padding: 0;
		width: 55px;
		height: 55px;
		outline: none;
		cursor: pointer;
		z-index: 2;
		position: absolute;
		top: 0;
		right: 0;

		img {
			width: 65%;
		}
		&:hover {
			background: linear-gradient(to left bottom, #3082a0 50%, #4d9ab3 50%);
		}
	}
	.menu {
		z-index: 1;
		background-color: #3e9698;
		position: absolute;
		right: -495px;
		width: 550px;
		overflow: hidden;
		height: 25px;
		top: 0;
		padding: 15px 0px;
		color: #fff;
		user-select: none;
		transition: all 0.5s linear;

		.title {
			margin: 0 5px 0 15px;
			text-transform: uppercase;
			font-size: 12px;
			font-weight: 600;
			float: left;
			line-height: 25px;
		}
		ul {
			list-style: none;
			text-align: left;
			padding: 0;
			margin: 0;
			float: left;

			li {
				font-size: 13px;
				float: left;
				line-height: 25px;

				a {
					color: #fff;
					cursor: pointer;
					border-right: 1px solid #fff;
					padding: 0px 10px;

					&:hover {
						color: #263b46;
					}
				}

				&:last-child {
					a {
						border-right: none;
					}
				}
			}
		}
	}
}
</style>
